<!DOCTYPE html>
<!--Start gursewak's Code date: 14-11-2022 : mystery box  -->

<!-- <img src="../../../assets/icon/iclose.svg" (click)="close()" class="close md-none" alt="" /> -->

@if (mysteryBoxData$ | async; as mysteryBox) {
  <div class="modal-container">
    <!-- <img src="../../../assets/icon/iclose.svg" (click)="close()" class="close xs-none" alt="" /> -->
    <div class="modal-card">
      <img src="{{mysteryBox?.data?.image_url}}" alt="mysteryBox" />
    </div>
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ autoShow ? ('MysteryBox.Mission_prize'| translate) : ('MysteryBox.Leveling_prize'| translate)}}</h2>
        <p>{{'MysteryBox.Your_prize'| translate}}</p>
      </div>
      @if (prizeListData$ | async; as prizeList) {
        <div class="modal-body" [ngStyle]="{'display': fadeOut && ctaType !== 'locked' ? 'none' : ''}" [ngClass]="{ 'fade-in': fadeIn && ctaType !== 'locked' }"
          >
          <mat-grid-list cols="3">
            @for (prizes of prizeList | keyvalue; track prizes; let i = $index) {
              <mat-grid-tile>
                <div class="prize-img">
                  <img src="{{prizes.value.prize.image_url}}" alt="" />
                  <span>{{prizeValues[i]}}</span>
                </div>
              </mat-grid-tile>
            }
          </mat-grid-list>
        </div>
      }
      @if (fadeOut && claimPrize) {
        <div class="modal-body-prize" [ngClass]="{ 'fade-out': fadeOut }">
          <img src="{{(claimPrize?.image_url.startsWith('http') ? claimPrize?.image_url : ('../../../../..'+ claimPrize?.image_url)) }}" class="claim-prize" alt="claimed-prize" />
          <p class="prize-value">{{PrizeValue}}</p>
          <button type="button" class="btn btn-light" (click)="close()">{{'MysteryBox.OK'| translate}}</button>
        </div>
      }
    </div>
  </div>
}
